import Link from "next/link";
import Image from "@/components/image";

export default function Split({ fields, first = false, sys, includes }) {
  const titleParts = fields.title && fields.title.split(" ");
  const last = titleParts.pop();
  const Title = ({ children }) => {
    return first ? (
      <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl">
        {children}
      </h1>
    ) : (
      <h3 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl">
        {children}
      </h3>
    );
  };
  return (
    <section className="relative">
      <div className="mx-auto max-w-7xl w-full pt-16 pb-20 text-center lg:py-48 lg:text-left">
        <div className="px-4 lg:w-1/2 sm:px-8 xl:pr-16">
          {fields.title && (
            <Title>
              <span className="block xl:inline">{titleParts.join(" ")}</span>
              {last && (
                <span className="block text-brand-600 xl:inline"> {last}</span>
              )}
            </Title>
          )}
          {fields.text && (
            <p className="mt-3 max-w-md mx-auto text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
              {fields.text}
            </p>
          )}
          <div className="mt-10 flex flex-col sm:justify-center lg:justify-start">
            {fields.actions &&
              fields.actions.map((action, index) => (
                <div
                  className={`rounded-md shadow mt-4`}
                  key={`${action.sys.id}-${index}`}
                >
                  <Link
                    href={action.fields.link}
                    className={`w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-sans rounded-md ${
                      index === 0
                        ? "text-white bg-brand-600 hover:bg-brand-700"
                        : "text-brand-500-700 bg-brand-100 hover:bg-brand-200"
                    } md:py-4 md:text-lg md:px-10`}
                  >
                    {action.fields.text}
                  </Link>
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full">
        {fields.image && (
          <Image
            alt=""
            fill
            fields={fields.image}
            className="absolute inset-0 w-full h-full object-cover"
          />
        )}
      </div>
    </section>
  );
}
